
export default {
  'altitudePreview': {
    'expandAltitudeChart': 'Agrandir le graphique',
    'altitude': 'Altitude'
  },
}
